import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../../js/app/react/validators';

import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import {
  BACKEND_KEY,
  LUMP_SUM,
  PENSIONS_CRUD_ADD_EDIT,
  PENSIONS_CRUD_OVERVIEW,
} from '../PensionWorkflowConstants';
import { isVisible } from '../../AdvWorkflow/AdvWorkflowHelpers';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';
import PensionAddEdit from './PensionAddEditContainer';

export const formatMoney = number => `$${window.ADV.util.number_format(number, 0, '.', ',')}`;

class PensionsOverviewView extends Component {
  componentDidUpdate(prevProps) {
    const { branch, iterator, fetchData, workflowId, clientId, dirtyNodesMap } = this.props;
    if (!isVisible(prevProps.branch, prevProps.iterator) && isVisible(branch, iterator)) {
      fetchData(workflowId, clientId, dirtyNodesMap);
    }
  }
  render() {
    const {
      branch,
      workflowId,
      clientId,
      pensions,
      graphPensions,
      onRemovePension,
      onAddPension,
      onEditPension,
      viewID,
      alreadyHasPensionData,
      hasPension,
      isEmptyState,
      onPostSave,
      shouldSkip,
    } = this.props;
    return (
      <AdvWorkflowStep
        branch={branch}
        workflowId={workflowId}
        id="PensionsOverview"
        canSkip={(!hasPension && !alreadyHasPensionData) || shouldSkip}
      >
        {viewID === PENSIONS_CRUD_OVERVIEW && (
          <div>
            <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.PensionsOverview`} />
            <h2>
              {hasPension && alreadyHasPensionData
                ? 'Tell us about your pensions.'
                : 'What are your pension details?'}
            </h2>
            <div className="adv-workflow-crud-widget">
              {isEmptyState ? (
                <div className="adv-workflow-crud-empty">
                  <div className="adv-workflow-crud-empty-add">
                    <button
                      className="adv-workflow-crud-empty-add-button"
                      type="button"
                      onClick={onAddPension(workflowId, clientId, graphPensions)}
                    >
                      <i className="adv-workflow-crud-empty-add-button-i">+</i>
                      <br />
                      Add a new pension
                    </button>
                  </div>
                </div>
              ) : (
                <div className="adv-workflow-crud-populated">
                  <ul className="adv-workflow-crud-populated-ul">
                    {pensions.map(
                      ({ Recipient, MonthlyPayment, PensionPlanType, LumpSumAmount, Id }) => (
                        <li className="adv-workflow-crud-populated-li">
                          <div className="adv-workflow-crud-populated-name-2">{`${Recipient}'s`}</div>
                          <div className="adv-workflow-crud-populated-value-2">
                            {formatMoney(
                              PensionPlanType === LUMP_SUM ? LumpSumAmount : MonthlyPayment,
                            )}
                          </div>
                          <div className="adv-workflow-crud-populated-actions">
                            <button
                              type="button"
                              className="adv-workflow-crud-populated-action"
                              aria-label="edit pension"
                              onClick={onEditPension(workflowId, clientId, Id)}
                            >
                              <i className="adv-workflow-crud-populated-action-i far fa-edit" />
                            </button>
                            <button
                              type="button"
                              className="adv-workflow-crud-populated-action"
                              aria-label="remove pension"
                              onClick={onRemovePension(workflowId, clientId, graphPensions, Id)}
                            >
                              <i className="adv-workflow-crud-populated-action-i far fa-trash-alt" />
                            </button>
                          </div>
                        </li>
                      ),
                    )}
                  </ul>
                  <div className="adv-workflow-crud-populated-add">
                    <button
                      className="adv-workflow-crud-populated-add-button"
                      onClick={onAddPension(workflowId, clientId, graphPensions)}
                      type="button"
                    >
                      <i className="adv-workflow-crud-populated-add-button-i">+</i>
                      Add a new pension
                    </button>
                  </div>
                </div>
              )}
            </div>
            <Navigation
              nextIterators={[]}
              dirtyGraphNodes={[]}
              workflowId={workflowId}
              backendKey={BACKEND_KEY}
              onPostSave={onPostSave(workflowId, clientId)}
              validationId={`${BACKEND_KEY}.PensionsOverview`}
              validatedOnClick={() => workflowAnalyticsEvents(workflowId, 'pension_info_completed')}
            />
          </div>
        )}
        {viewID === PENSIONS_CRUD_ADD_EDIT && <PensionAddEdit workflowId={workflowId} />}
      </AdvWorkflowStep>
    );
  }
}

PensionsOverviewView.defaultProps = {
  iterator: null,
  hasPension: false,
};

PensionsOverviewView.propTypes = {
  shouldSkip: PropTypes.bool.isRequired,
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  iterator: PropTypes.arrayOf(PropTypes.number.isRequired),
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  fetchData: PropTypes.func.isRequired,
  onRemovePension: PropTypes.func.isRequired,
  onEditPension: PropTypes.func.isRequired,
  onAddPension: PropTypes.func.isRequired,
  onPostSave: PropTypes.func.isRequired,
  hasPension: PropTypes.bool,
  pensions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  graphPensions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isEmptyState: PropTypes.bool.isRequired,
  viewID: PropTypes.oneOf([PENSIONS_CRUD_ADD_EDIT, PENSIONS_CRUD_OVERVIEW]).isRequired,
  dirtyNodesMap: PropTypes.shape({}).isRequired,
  alreadyHasPensionData: PropTypes.bool.isRequired,
};

export default PensionsOverviewView;
